import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { selectPermisos } from '../../store/selectors/permisos.selector';
import { catchError, filter, map, of, take, timeout } from 'rxjs';
import { PermisosState } from '../interfaces/models/permisos.interface';
import { AlertService } from '../services/alert.service';

export const PermisoGuard: CanActivateFn = (route, state) => {
  const store = inject(Store<{ permisosState: PermisosState }>);
  const alertService = inject(AlertService);
  const router = inject(Router);

  const requiredPermisos = route.data['permisos'] as string[];
  const modo = (route.data['modo'] as 'union' | 'interseccion') ?? 'union'; // por defecto unión

  if (!requiredPermisos || requiredPermisos.length === 0) {
    return of(true);
  }

  return store.select(selectPermisos).pipe(
    filter((p) => p != null && p.length > 0),
    take(1),
    timeout(10000),
    map((permisos: string[]) => {
      let hasAccess = false;
      if (modo === 'union') {
        hasAccess = requiredPermisos.some(p => permisos.includes(p));
      } else {
        hasAccess = requiredPermisos.every(p => permisos.includes(p));
      }

      if (hasAccess || state.url === '/dashboard') {
        return true;
      }

      // Sin permiso: un único destino final (dashboard) desde el onConfirm.
      const mensajeHtml = `
        <p>No tenés permisos para acceder a esta sección.</p>
        <ul style="text-align: left; margin-top: 10px;">
          <li><strong>Botón INICIO:</strong> cancela la operación y te redirige al menú principal.</li>
        </ul>
      `;
      alertService.showStructuredWarning({
        title: 'Permisos de Navegación',
        causeHtml: mensajeHtml,
        cause: '',
        solution: 'Contactá a tu administrador para modificar la configuración.',
        confirmButtonText: 'INICIO',
        showCancelButton: false,
        onConfirm: () => {
          router.navigate(['dashboard']);
        }
      });
      return false;
    }),
    // FIX CP-PRM-008: antes el catchError del timeout navegaba a /auth/ingreso
    // y devolvía of([]); como [] es truthy, el evaluador seguía y además mostraba
    // el warning cuyo onConfirm navegaba a /dashboard -> dos navegaciones en
    // conflicto. Ahora el timeout tiene UN solo destino y devuelve false directo.
    catchError(() => {
      router.navigate(['/auth/ingreso']);
      return of(false);
    })
  );
};